import React from "react";

import { ReactComponent as Logo } from "../../../../assets/svg/logo.svg";
import { ReactComponent as EyeOpen } from "../../../../assets/svg/eye_open.svg";
import { ReactComponent as EyeClose } from "../../../../assets/svg/eye_close.svg";
import styles from "../Login.module.scss";

type Props = {
  calling: boolean;
  updatePassword: (password: string) => void;
};

const validates: { [key: string]: (value: any) => string } = {};

validates["password"] = val => {
  return !val.password.trim()
    ? "この項目は入力が必須です。"
    : val.password.length < 6 || val.password.length > 32
    ? "パスワードは6文字以上32文字以内で入力してください。"
    : "";
};

validates["passwordConfirm"] = val => {
  return !val.passwordConfirm.trim()
    ? "この項目は入力が必須です。"
    : val.passwordConfirm.length < 6 || val.passwordConfirm.length > 32
    ? "パスワードは6文字以上32文字以内で入力してください。"
    : val.password !== val.passwordConfirm
    ? "パスワードが一致しません。"
    : "";
};

export const ResetPasswordForm = (props: Props) => {
  const [visible, setVisible] = React.useState({
    password: false,
    confirmPassword: false,
  });
  const [state, setState] = React.useState({
    password: "",
    passwordConfirm: "",
    errorMessages: {} as { [key: string]: string },
  });

  const onSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const errorMessages = {} as { [key: string]: string };
      Object.keys(validates).forEach(key => {
        const ret = validates[key](state);
        if (ret) {
          errorMessages[key] = ret;
        }
      });
      if (Object.keys(errorMessages).length > 0) {
        setState(s => ({ ...s, errorMessages }));
        return;
      }
      props.updatePassword(state.password);
    },
    [state, props],
  );

  const onChange = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      e.preventDefault();
      const val = e.currentTarget.value;
      const key = e.currentTarget.name;
      setState(prevState => {
        const errorMessages = {} as { [key: string]: string };
        const arg = { ...prevState, [key]: val };
        Object.keys(validates).forEach(k => {
          errorMessages[k] = validates[k](arg);
        });
        return {
          ...arg,
          errorMessages,
        };
      });
    },
    [],
  );

  return (
    <div className={styles.wrapper}>
      <Logo className={styles.logo} />
      <form className={styles.content} onSubmit={onSubmit}>
        <div className={styles.title}>
          <p className={styles.primary}>パスワード登録</p>
          <p className={styles.secondary}>生徒</p>
        </div>
        <p className={styles.text}>
          あなたのパスワードを登録してください。
          <br />
          今後は登録したパスワードでログインできます。
        </p>
        <div className={styles.inputField}>
          <fieldset>
            <div className={styles.inputWrapper}>
              <input
                type={visible.password ? "text" : "password"}
                name="password"
                className={
                  state.errorMessages["password"] ? styles.isError : ""
                }
                id="password"
                value={state.password}
                onChange={onChange}
                onBlur={onChange}
                placeholder="パスワードを入力"
              />
              <span
                className={styles.eyeIcon}
                onClick={() => {
                  setVisible({
                    ...visible,
                    password: !visible.password,
                  });
                }}
              >
                {visible.password ? <EyeOpen /> : <EyeClose />}
              </span>
            </div>
            {state.errorMessages["password"] && (
              <p className={styles.errorMessage}>
                {state.errorMessages["password"]}
              </p>
            )}
          </fieldset>
          <fieldset>
            <div className={styles.inputWrapper}>
              <input
                type={visible.confirmPassword ? "text" : "password"}
                id="passwordConfirm"
                name="passwordConfirm"
                className={
                  state.errorMessages["passwordConfirm"] ? styles.isError : ""
                }
                value={state.passwordConfirm}
                onChange={onChange}
                onBlur={onChange}
                placeholder="確認用パスワードを入力"
              />
              <span
                className={styles.eyeIcon}
                onClick={() => {
                  setVisible({
                    ...visible,
                    confirmPassword: !visible.confirmPassword,
                  });
                }}
              >
                {visible.confirmPassword ? <EyeOpen /> : <EyeClose />}
              </span>
            </div>
            {state.errorMessages["passwordConfirm"] && (
              <div className={styles.errorMessage}>
                {state.errorMessages["passwordConfirm"]}
              </div>
            )}
          </fieldset>
        </div>
        <button
          className={styles.submitButton}
          type="submit"
          disabled={
            Object.keys(state.errorMessages).filter(k => state.errorMessages[k])
              .length > 0 || props.calling
          }
        >
          登録
        </button>
      </form>
    </div>
  );
};

export default ResetPasswordForm;
